import { useMemo } from 'react';

import { Box, BoxProps } from '@mui/material';

import { Offering } from '@arrived/models';

import { AssetManagementFee } from './AssetManagementFee';
import { HoldPeriod } from './HoldPeriod';
import { OfferingTermsDetail, OfferingTermsDetailsList } from './OfferingTermsDetailsList';
import { PropertyAmountBreakdown } from './PropertyAmountBreakdown';
import { PropertyAmountTotal } from './PropertyAmountTotal';
import { PROPERTY_COSTS_DETAILS, SHARES_DETAILS } from './PropertyDetailsOfferingTerms.config';

export interface PropertyDetailsOfferingTermsProps extends BoxProps {
  offering: Offering;
}

export const PropertyDetailsOfferingTerms = ({ offering, ...rest }: PropertyDetailsOfferingTermsProps) => {
  const costDetails = useMemo(
    (): OfferingTermsDetail[] =>
      PROPERTY_COSTS_DETAILS.map(({ valueFn, ...rest }) => ({
        ...rest,
        value: valueFn(offering),
      })),
    [offering]
  );

  const shareDetails = useMemo(
    (): OfferingTermsDetail[] =>
      SHARES_DETAILS.map(({ valueFn, ...rest }) => ({
        ...rest,
        value: valueFn(offering),
      })),
    [offering]
  );

  return (
    <Box {...rest}>
      <OfferingTermsDetailsList details={costDetails} />
      <PropertyAmountTotal mb={1} offering={offering} />
      <PropertyAmountBreakdown offering={offering} />
      <OfferingTermsDetailsList details={shareDetails} />
      <HoldPeriod mt={1} offering={offering} />
      <AssetManagementFee offering={offering} />
    </Box>
  );
};
